import AnalyticsTwoToneIcon from '@mui/icons-material/AnalyticsTwoTone';
// import HealthAndSafetyTwoToneIcon from '@mui/icons-material/HealthAndSafetyTwoTone';
import AssignmentIndTwoToneIcon from '@mui/icons-material/AssignmentIndTwoTone';
// import AccountTreeTwoToneIcon from '@mui/icons-material/AccountTreeTwoTone';
// import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
// import DesignServicesTwoToneIcon from '@mui/icons-material/DesignServicesTwoTone';
// import SupportTwoToneIcon from '@mui/icons-material/SupportTwoTone';
// import ReceiptTwoToneIcon from '@mui/icons-material/ReceiptTwoTone';
import SmsIcon from '@mui/icons-material/Sms';
import CallTwoToneIcon from '@mui/icons-material/CallTwoTone';
import PrecisionManufacturingTwoToneIcon from '@mui/icons-material/PrecisionManufacturingTwoTone';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import StorefrontTwoToneIcon from '@mui/icons-material/StorefrontTwoTone';
import AutoAwesomeTwoToneIcon from '@mui/icons-material/AutoAwesomeTwoTone';
import CampaignTwoToneIcon from '@mui/icons-material/CampaignTwoTone';
import LanguageTwoToneIcon from '@mui/icons-material/LanguageTwoTone';
import BuildCircleTwoToneIcon from '@mui/icons-material/BuildCircleTwoTone';
import InventoryTwoToneIcon from '@mui/icons-material/InventoryTwoTone';
import SmartDisplayTwoToneIcon from '@mui/icons-material/SmartDisplayTwoTone';
import BugReportTwoToneIcon from '@mui/icons-material/BugReportTwoTone';
import GroupsTwoToneIcon from '@mui/icons-material/GroupsTwoTone';

const menuItems = [
  {
    heading: 'General',
    items: [
      {
        name: 'Work Flow',
        icon: PrecisionManufacturingTwoToneIcon,
        // badge: 'v3',
        link: '/app/applications/workflow',
        // items: [
        //   {
        //     name: 'Extended sidebar',
        //     link: '/extended-sidebar/dashboards'
        //   },
        //   {
        //     name: 'Accent header',
        //     link: '/accent-header/dashboards',
        //     badge: '',
        //     badgeTooltip: 'Updated'
        //   },
        //   {
        //     name: 'Accent sidebar',
        //     link: '/accent-sidebar/dashboards'
        //   },
        //   {
        //     name: 'Boxed sidebar',
        //     link: '/boxed-sidebar/dashboards'
        //   },
        //   {
        //     name: 'Collapsed sidebar',
        //     link: '/app/dashboards'
        //   },
        //   {
        //     name: 'Bottom navigation',
        //     link: '/bottom-navigation/dashboards'
        //   },
        //   {
        //     name: 'Top navigation',
        //     link: '/top-navigation/dashboards'
        //   }
        // ]
      },
      {
        name: 'Phone',
        icon: CallTwoToneIcon,
        link: '/app/applications/phone',
      },
      {
        name: 'Jarvis',
        icon: AutoAwesomeTwoToneIcon,
        link: '/app/applications/jarvis',
      },
      {
        name: 'Messenger',
        icon: SmsIcon,
        link: '/app/applications/messenger',
      },
      {
        name: 'Team Messenger',
        icon: GroupsTwoToneIcon,
        link: '/app/applications/team-messenger'
      },
      {
        name: 'Dealership Manager',
        icon: StorefrontTwoToneIcon,
        link: '/app/applications/dealership/inventory'
      },
      {
        name: 'Website Manager',
        icon: LanguageTwoToneIcon,
        link: '/app/applications/website-manager'
      },
      {
        name: 'SMS Marketing',
        icon: CampaignTwoToneIcon,
        link: '/app/applications/sms-marketing'
      },
      {
        name: 'TikTok',
        icon: SmartDisplayTwoToneIcon,
        link: '/app/dashboards/tiktok'
      },
      {
        name: 'Users',
        icon: AssignmentIndTwoToneIcon,
        link: 'management/users/list',
        // items: [
        //   {
        //     name: 'List',
        //     link: 'management/users/list'
        //   },
        //   {
        //     name: 'User Profile',
        //     link: 'management/users/single'
        //   }
        // ]
      },
      {
        name: 'Calendar',
        icon: CalendarTodayIcon,
        link: '/app/applications/calendar',
      },
      {
        name: 'Canned Jobs',
        icon: BuildCircleTwoToneIcon,
        link: '/app/management/services'
      },
      {
        name: 'Parts Inventory',
        icon: InventoryTwoToneIcon,
        link: '/app/management/parts-inventory'
      },
      {
        name: 'Error Monitor',
        icon: BugReportTwoToneIcon,
        link: '/app/management/error-monitor',
        roles: ['owner', 'admin'],
        errorMonitorAccess: true
      },
      {
        name: 'Business Reports',
        icon: AnalyticsTwoToneIcon,
        link: '/app/dashboards',
        items: [
          {
            name: 'Technician Labor',
            link: 'dashboards/technician-labor'
          },
          // {
          //   name: 'Reports',
          //   link: 'dashboards/reports',
          //   badge: '',
          //   badgeTooltip: 'Reports Dashboard - version 3.0'
          // },
          {
            name: 'Profit Margins',
            link: 'dashboards/expenses',
            badge: '',
            // badgeTooltip: 'Expenses Dashboard - version 3.0'
          },
          // {
          //   name: 'Products',
          //   link: 'dashboards/products',
          //   badge: '',
          //   badgeTooltip: 'Products Dashboard - version 3.0'
          // },
          // {
          //   name: 'Sales Statistics',
          //   link: 'dashboards/statistics',
          //   badge: '',
          //   // badgeTooltip: 'Statistics Dashboard - version 3.0'
          // },
          // {
          //   name: 'Automation',
          //   link: 'dashboards/automation'
          // },
          {
            name: 'Customer Acquisition',
            link: 'dashboards/analytics'
          },
          {
            name: 'Google Analytics',
            link: 'dashboards/google-analytics'
          },
          {
            name: 'Google Business',
            link: 'dashboards/google-business'
          },
          {
            name: 'Google Ads',
            link: 'dashboards/google-ads'
          },
          // {
          //   name: 'Banking',
          //   link: 'dashboards/banking'
          // },
          // {
          //   name: 'Commerce',
          //   link: 'dashboards/commerce'
          // },
          // {
          //   name: 'Crypto',
          //   link: 'dashboards/crypto'
          // },
          // {
          //   name: 'Finance',
          //   link: 'dashboards/finance'
          // },
          // {
          //   name: 'Fitness',
          //   link: 'dashboards/fitness'
          // },
          // {
          //   name: 'Doctors',
          //   link: 'dashboards/healthcare/doctor'
          // },
          // {
          //   name: 'Hospital',
          //   link: 'dashboards/healthcare/hospital'
          // },
          // {
          //   name: 'Helpdesk',
          //   link: 'dashboards/helpdesk'
          // },
          // {
          //   name: 'Learning',
          //   link: 'dashboards/learning'
          // },
          // {
          //   name: 'Monitoring',
          //   link: 'dashboards/monitoring'
          // },
          // {
          //   name: 'Tasks',
          //   link: 'dashboards/tasks'
          // }
        ]
      },
      // {
      //   name: 'Invoices',
      //   icon: ReceiptTwoToneIcon,
      //   link: '/app/management/invoices/list',
      // },
      // {
      //   name: 'Data Display',
      //   icon: HealthAndSafetyTwoToneIcon,
      //   badge: '',
      //   link: '/app/blocks',
      //   items: [
      //     {
      //       name: 'Charts large',
      //       link: 'blocks/charts-large'
      //     },
      //     {
      //       name: 'Charts small',
      //       link: 'blocks/charts-small'
      //     },
      //     {
      //       name: 'Composed cards',
      //       link: 'blocks/composed-cards'
      //     },
      //     {
      //       name: 'Grids',
      //       link: 'blocks/grids'
      //     },
      //     {
      //       name: 'Icon cards',
      //       link: 'blocks/icon-cards'
      //     },
      //     {
      //       name: 'Image cards',
      //       link: 'blocks/image-cards'
      //     },
      //     {
      //       name: 'Lists large',
      //       link: 'blocks/lists-large'
      //     },
      //     {
      //       name: 'Lists small',
      //       link: 'blocks/lists-small'
      //     },
      //     {
      //       name: 'Navigation',
      //       link: 'blocks/navigation'
      //     },
      //     {
      //       name: 'Profile cards',
      //       link: 'blocks/profile-cards'
      //     },
      //     {
      //       name: 'Progress circular',
      //       link: 'blocks/progress-circular'
      //     },
      //     {
      //       name: 'Progress horizontal',
      //       link: 'blocks/progress-horizontal'
      //     },
      //     {
      //       name: 'Sparklines large',
      //       link: 'blocks/sparklines-large'
      //     },
      //     {
      //       name: 'Sparklines small',
      //       link: 'blocks/sparklines-small'
      //     },
      //     {
      //       name: 'Statistics',
      //       link: 'blocks/statistics'
      //     }
      //   ]
      // },
      // {
      //   name: 'Applications',
      //   icon: AnalyticsTwoToneIcon,
      //   link: '/app/applications',
      //   items: [
      //     {
      //       name: 'Calendar',
      //       link: 'applications/calendar'
      //     },
      //     {
      //       name: 'File Manager',
      //       link: 'applications/file-manager'
      //     },
      //     {
      //       name: 'Jobs Platform',
      //       link: 'applications/jobs-platform'
      //     },
      //     {
      //       name: 'Mailbox',
      //       link: 'applications/mailbox/inbox'
      //     },
      //     {
      //       name: 'Messenger',
      //       link: 'applications/messenger'
      //     },
      //     {
      //       name: 'Projects Board',
      //       link: 'applications/projects-board'
      //     }
      //   ]
      // }
    ]
  },
  // {
  //   heading: 'Management',
  //   items: [
  //     {
  //       name: 'Projects',
  //       icon: AccountTreeTwoToneIcon,
  //       link: '/app/management/projects/list'
  //     },
  //     {
  //       name: 'Commerce',
  //       icon: StorefrontTwoToneIcon,
  //       link: '/app/management/commerce',
  //       items: [
  //         {
  //           name: 'Shop',
  //           link: 'management/commerce/shop'
  //         },
  //         {
  //           name: 'List',
  //           link: 'management/commerce/products/list'
  //         },
  //         {
  //           name: 'Details',
  //           link: 'management/commerce/products/single/1'
  //         },
  //         {
  //           name: 'Create',
  //           link: 'management/commerce/products/create'
  //         }
  //       ]
  //     },
  //     {
  //       name: 'Invoices',
  //       icon: ReceiptTwoToneIcon,
  //       link: '/app/management/invoices',
  //       items: [
  //         {
  //           name: 'List',
  //           link: 'management/invoices/list'
  //         },
  //         {
  //           name: 'Details',
  //           link: 'management/invoices/single'
  //         }
  //       ]
  //     }
  //   ]
  // },
  // {
  //   heading: 'Foundation',
  //   items: [
  //     {
  //       name: 'Overview',
  //       link: '/overview',
  //       icon: DesignServicesTwoToneIcon
  //     },
  //     {
  //       name: 'Documentation',
  //       icon: SupportTwoToneIcon,
  //       link: '/docs'
  //     }
  //   ]
  // }
];

export default menuItems;
